import Vue from 'vue'
import Vuex from 'vuex'
import { uuid } from 'vue-uuid';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedDecades: JSON.parse(localStorage.getItem('selectedDecades') || '[]'),
    selectedSeasons: [],
    selectedLeagues: [],
    playerplayedCount: parseInt(localStorage.playerplayedCount) || 0,
    playerplayed: JSON.parse(localStorage.getItem('playerplayed') || '[]'),
    question1Count: parseInt(localStorage.question1Count) || 0,
    question2Count: parseInt(localStorage.question2Count) || 0,
    question3Count: parseInt(localStorage.question3Count) || 0,
    legendsCount: parseInt(localStorage.legendsCount) || 0,
    legends: JSON.parse(localStorage.getItem('legends') || '[]'),
    krampenCount: parseInt(localStorage.krampenCount) || 0,
    krampen: JSON.parse(localStorage.getItem('krampen') || '[]'),
    uuid: localStorage.getItem('uuid') || uuid.v4(),
    datapatch_version: parseInt(localStorage.datapatch_version) || 0,
  },
  mutations: {
    "UPDATE_SELECTED_DECADES" (state, dacades) {
      state.selectedDecades = dacades

      console.log("put localStorage: "+state.selectedDecades)
      localStorage.setItem('selectedDecades', JSON.stringify(state.selectedDecades))
    },
    "UPDATE_SELECTED_SEASONS" (state, seasons) {      
      console.log("mutation UPDATE_SELECTED_SEASONS")
      state.selectedSeasons = seasons
    }, 
    "UPDATE_SELECTED_LEAGUES" (state, leagues) {
      state.selectedLeagues = leagues
    },
    "PLAYER_PLAYED_COUNT" (state, pp) {
      state.playerplayedCount += pp

      console.log("############################################")
      console.log(state.playerplayedCount)
      console.log("############################################")
      localStorage.setItem('playerplayedCount', state.playerplayedCount)
    },
    "PLAYER_PLAYED" (state, pp) {
      console.log("-----------------------------------------X")
      state.playerplayed.push(pp)

      console.log("-----------------------------------------X")
      localStorage.setItem('playerplayed', JSON.stringify(state.playerplayed))

      console.log("-----------------------------------------X")
    },
    "QUESTIONS_STATS" (state, q) {
      if ( q.q1 ) state.question1Count += 1
      if ( q.q2 ) state.question2Count += 1
      if ( q.q3 ) state.question3Count += 1

      localStorage.setItem('question1Count', state.question1Count)
      localStorage.setItem('question2Count', state.question2Count)
      localStorage.setItem('question3Count', state.question3Count)
    },
    "LEGENDS_COUNT" (state, pp) {
      state.legendsCount += pp
      localStorage.setItem('legendsCount', state.legendsCount)
    },
    "LEGENDS" (state, pp) {
      state.legends.push(pp)
      localStorage.setItem('legends', JSON.stringify(state.legends))
    },
    "KRAMPEN_COUNT" (state, pp) {
      state.krampenCount += pp
      localStorage.setItem('krampenCount', state.krampenCount)
    },
    "KRAMPEN" (state, pp) {
      state.krampen.push(pp)
      localStorage.setItem('krampen', JSON.stringify(state.krampen))
    },
    "RESET_STATS" (state) {
      state.playerplayedCount = 0
      state.playerplayed = []
      state.question1Count = 0
      state.question2Count = 0
      state.question3Count = 0
      state.legendsCount = 0
      state.legends = []
      state.krampenCount = 0
      state.krampen = []
      
      localStorage.playerplayedCount = ''
      localStorage.setItem('playerplayed', '')
      localStorage.question1Count = ''
      localStorage.question2Count = ''
      localStorage.question3Count = ''
      localStorage.legendsCount = ''
      localStorage.setItem('legends', '')
      localStorage.krampenCount = ''
      localStorage.setItem('krampen', '')
    },
    "PATCH_VERSION_2" (state) {
      console.log("PatchMeHereRightNow")

      var result = []
      state.playerplayed.forEach(player => {
        if ( player.name ) {
          result.push({
            player
          })
        } else {
          result.push(player)
        }
      })
      state.playerplayed = result
      state.datapatch_version = 2

      localStorage.setItem('playerplayed', JSON.stringify(state.playerplayed))
      localStorage.datapatch_version = state.datapatch_version
    }
  },
  actions: {
    updateSelectedDecades(context, dacades) {
      console.log("update Selected Decades")
      context.commit("UPDATE_SELECTED_DECADES", dacades)
    },
    updateSelectedSeasons(context, seasons) {
      console.log("storeAction updateSelectedSeasons")
      context.commit("UPDATE_SELECTED_SEASONS", seasons)
    }, 
    updateSelectedLeagues(context, leagues) {
      context.commit("UPDATE_SELECTED_LEAGUES", leagues)
    },
    addPlayerPlayed(context, player) {
      context.commit("PLAYER_PLAYED_COUNT", 1)
      context.commit("PLAYER_PLAYED", player)
    },
    updateQuestionStats(context, q) {
      context.commit("QUESTIONS_STATS", q)
    },
    addLegend(context, player) {
      context.commit("LEGENDS_COUNT", 1)
      context.commit("LEGENDS", player)
    },
    addKrampe(context, player) {
      context.commit("KRAMPEN_COUNT", 1)
      context.commit("KRAMPEN", player)
    },
    resetStats(context) {
      context.commit("RESET_STATS")
    }, 
    patchVersion2(context) {
      context.commit("PATCH_VERSION_2")
    }
  },
  modules: {
  },
  getters: {
    getSelectedDecades: state => {
      return state.selectedDecades
    },
    getSelectedSeasons: state => {
      return state.selectedSeasons
    },
    getSelectedLeagues: state => {
      return state.selectedLeagues
    },
    getPlayerPlayedCount: state => {
      return state.playerplayedCount
    },
    getPlayerPlayed: state => {
      return state.playerplayed
    },
    getQuestion1Count: state => {
      return state.question1Count
    },
    getQuestion2Count: state => {
      return state.question2Count
    },
    getQuestion3Count: state => {
      return state.question3Count
    },
    getLegendsCount: state => {
     return state.legendsCount
    },
    getLegends: state => {
      return state.legends
     },
    getKrampenCount: state => {
      return state.krampenCount
    },
    getKrampen: state => {
      return state.krampen
    },
    getUuid: state  => {
      return state.uuid
    },
    getDataPatchVersion: state => {
      return state.datapatch_version
    }
  }
})
